/**
 * Medbook
 * Medbook api
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 */
export interface CourseModuleItemFile { 
    /**
     * 
     */
    type: CourseModuleItemFile.TypeEnum;
    /**
     * 
     */
    url?: string;
    /**
     * 
     */
    name?: string;
    /**
     * 
     */
    size?: number;
    /**
     * 
     */
    id: string;
}
export namespace CourseModuleItemFile {
    export type TypeEnum = 'file' | 'link';
    export const TypeEnum = {
        File: 'file' as TypeEnum,
        Link: 'link' as TypeEnum
    };
}


